import "./footer.css";
import { useContext } from "react";
import { FiMail, FiPhone } from "react-icons/fi";
import { FaAddressCard, FaCalendarAlt } from "react-icons/fa";
import {
  FaFacebookSquare,
  FaLinkedin,
  FaYoutube,
  FaPinterestSquare,
} from "react-icons/fa";
import { FaInstagram, FaXTwitter } from "react-icons/fa6";
import { LanguageContext } from "../../context/LanguageContext";

const Footer = () => {
  const { t } = useContext(LanguageContext);

  return (
    <footer className="footer royal-footer">
      <div className="royal-corner corner-tl"></div>
      <div className="royal-corner corner-tr"></div>
      <div className="royal-corner corner-bl"></div>
      <div className="royal-corner corner-br"></div>

      <div className="footer-container">
        <div className="footer-links">
          <div>
            <h4>{t(`footer.houseOfPandey`)}</h4>
            <ul>
              <li><a href="/">{t(`footer.home`)}</a></li>
              <li><a href="/category">{t(`footer.category`)}</a></li>
              <li><a href="/blog">{t(`footer.blog`)}</a></li>
              <li><a href="/aboutus">{t(`footer.aboutUs`)}</a></li>
              <li><a href="/contactus">{t(`footer.contactUs`)}</a></li>
            </ul>
          </div>

          <div>
            <h4>{t(`footer.quickLinks`)}</h4>
            <ul>
              <li><a href="/how-it-works">{t(`footer.howItWorks`)}</a></li>
            </ul>
          </div>

          <div>
            <h4>{t(`footer.needHelp`)}</h4>
            <ul>
              <li><a href="/faqs">{t(`footer.faqs`)}</a></li>
              <li><a href="/stores">{t(`footer.stores`)}</a></li>
              <li><a href="tel:+918905046144">{t(`footer.callUs`)}</a></li>
              <li>
                <a href="mailto:harshpandey9079@gmail.com">
                  {t(`footer.EmailUs`)}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-social">
            <h4>{t(`footer.followUs`)}</h4>
            <a href="#" className="social-link"><FaInstagram /> Instagram</a>
            <a href="#" className="social-link"><FaPinterestSquare /> Pinterest</a>
            <a href="#" className="social-link"><FaFacebookSquare /> Facebook</a>
            <a href="#" className="social-link"><FaYoutube /> YouTube</a>
            <a href="#" className="social-link"><FaXTwitter /> Twitter</a>
            <a href="#" className="social-link"><FaLinkedin /> LinkedIn</a>
          </div>
        </div>
      </div>

      {/* Store Section */}
      <div className="store">
        <div className="store-info">
          <img
            src="/assets/logo/logobgwhite.png"
            alt="Logo"
            className="footer-logo"
          />
          <h3>{t(`footer.shopName`)}</h3>

          <p><FaAddressCard /> {t(`footer.addressDetails`)}</p>
          <p><FiPhone /> <a href="tel:+918905046144">{t(`footer.CallValue`)}</a></p>
          <p><FiMail /> <a href="mailto:harshpandey9079@gmail.com">{t(`footer.EmailValue`)}</a></p>
          <p><FaCalendarAlt /> {t(`footer.workingHours`)}</p>
        </div>

        <div className="store-map">
          <iframe
            title="Shri Hari Om Moorti Bhandar"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.1257612963733!2d75.81266207504172!3d26.923385776657083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4b20b944839f%3A0xc8fe880c2dcecf71!2sShri%20Hari%20Om%20Moorti%20Bhandar%2C%20Jaipur!5e0!3m2!1sen!2sin!4v1727209500000!5m2!1sen!2sin"
            loading="lazy"
          />
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} {t(`footer.rightsReserved`)}
      </div>
    </footer>
  );
};

export default Footer;